// ============================================
// RABEEA SIDDIQUI - V1 SHOPIFY THEME
// Animations & Interactions
// ============================================

(function() {
  'use strict';

  // ---------- Loader ----------
  function initLoader() {
    const loader = document.querySelector('.v1-loader');
    if (loader) {
      // Hide loader after page load + delay
      setTimeout(() => {
        loader.classList.add('v1-loader--hidden');
      }, 1500);
    }
  }

  // ---------- Mobile Menu ----------
  function initMobileMenu() {
    const menuBtn = document.querySelector('.v1-header__menu-btn');
    const mobileMenu = document.querySelector('.v1-mobile-menu');
    const mobileLinks = document.querySelectorAll('.v1-mobile-menu__link');

    if (!menuBtn || !mobileMenu) return;

    menuBtn.addEventListener('click', () => {
      menuBtn.classList.toggle('active');
      mobileMenu.classList.toggle('active');
      document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
    });

    mobileLinks.forEach(link => {
      link.addEventListener('click', () => {
        menuBtn.classList.remove('active');
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      });
    });
  }

  // ---------- Scroll Animations ----------
  function initScrollAnimations() {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -50px 0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('v1-animate');
        }
      });
    }, observerOptions);

    // Observe all elements with data-v1-animate
    document.querySelectorAll('[data-v1-animate]').forEach(el => {
      observer.observe(el);
    });

    // Observe gallery items with stagger
    const galleryItems = document.querySelectorAll('.v1-gallery__item');
    galleryItems.forEach((item, index) => {
      item.style.transitionDelay = `${index * 0.1}s`;
      observer.observe(item);
    });

    // Observe services items with stagger
    const serviceItems = document.querySelectorAll('.v1-services__item');
    serviceItems.forEach((item, index) => {
      item.style.transitionDelay = `${index * 0.15}s`;
      observer.observe(item);
    });

    // Observe staging features with stagger
    const stagingFeatures = document.querySelectorAll('.v1-staging__feature');
    stagingFeatures.forEach((item, index) => {
      item.style.transitionDelay = `${index * 0.15}s`;
      observer.observe(item);
    });
  }

  // ---------- Smooth Scroll ----------
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#' || href === '#0' || !href) return;

        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });

    // Logo click: scroll to top if already on homepage
    const logo = document.querySelector('.v1-header__logo');
    if (logo) {
      logo.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '/' && window.location.pathname === '/') {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
          history.replaceState(null, '', '/');
        }
      });
    }
  }

  // ---------- Header Scroll Effect ----------
  function initHeaderScroll() {
    const header = document.querySelector('.v1-header');
    if (!header) return;

    let ticking = false;

    function updateHeader() {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll > 100) {
        header.classList.add('v1-header--scrolled');
      } else {
        header.classList.remove('v1-header--scrolled');
      }

      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });

    // Initial check
    updateHeader();
  }

  // ---------- Parallax Effect on Hero Image ----------
  function initParallax() {
    const heroImage = document.querySelector('.v1-hero__image img');
    const heroSection = document.querySelector('.v1-hero');

    if (!heroImage || !heroSection) return;

    let ticking = false;

    function updateParallax() {
      const scrolled = window.pageYOffset || document.documentElement.scrollTop;
      const heroHeight = heroSection.offsetHeight;

      if (scrolled < heroHeight) {
        heroImage.style.transform = `scale(1) translateY(${scrolled * 0.3}px)`;
      }

      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
  }

  // ---------- Custom Cursor (Desktop Only) ----------
  function initCustomCursor() {
    if (window.innerWidth <= 968) return;

    // Check if cursor already exists
    if (document.querySelector('.v1-custom-cursor')) return;

    const cursor = document.createElement('div');
    cursor.className = 'v1-custom-cursor';
    cursor.innerHTML = '<div class="v1-cursor-dot"></div><div class="v1-cursor-ring"></div>';
    document.body.appendChild(cursor);

    let mouseX = 0, mouseY = 0;
    let cursorX = 0, cursorY = 0;

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    }, { passive: true });

    function animateCursor() {
      cursorX += (mouseX - cursorX) * 0.1;
      cursorY += (mouseY - cursorY) * 0.1;
      cursor.style.left = cursorX + 'px';
      cursor.style.top = cursorY + 'px';
      requestAnimationFrame(animateCursor);
    }
    animateCursor();

    // Cursor hover effect on interactive elements
    const interactiveElements = document.querySelectorAll('a, button, .v1-gallery__item');
    interactiveElements.forEach(el => {
      el.addEventListener('mouseenter', () => {
        const ring = cursor.querySelector('.v1-cursor-ring');
        if (ring) {
          ring.style.transform = 'translate(-50%, -50%) scale(1.5)';
          ring.style.opacity = '0.3';
        }
      });
      el.addEventListener('mouseleave', () => {
        const ring = cursor.querySelector('.v1-cursor-ring');
        if (ring) {
          ring.style.transform = 'translate(-50%, -50%) scale(1)';
          ring.style.opacity = '0.5';
        }
      });
    });
  }

  // ---------- Image Lazy Loading with Fade ----------
  function initImageFade() {
    const images = document.querySelectorAll('.v1-hero img, .v1-gallery img, .v1-staging img, .v1-about img');

    images.forEach(img => {
      if (img.complete) {
        img.style.opacity = '1';
      } else {
        img.style.opacity = '0';
        img.style.transition = 'opacity 0.5s ease';
        img.addEventListener('load', () => {
          img.style.opacity = '1';
        });
      }
    });
  }

  // ---------- Initialize Everything ----------
  function init() {
    initLoader();
    initMobileMenu();
    initScrollAnimations();
    initSmoothScroll();
    initHeaderScroll();
    initParallax();
    initCustomCursor();
    initImageFade();

    console.log('✨ Rabeea Siddiqui V1 Theme Loaded');
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section events (for theme editor)
  document.addEventListener('shopify:section:load', () => {
    initMobileMenu();
    initScrollAnimations();
    initSmoothScroll();
    initHeaderScroll();
  });

})();
